export default {
  'Edit': '편집',
  'Save': '저장',
  'Cancel': '취소',
  'Ok': '확인',
  'and': '그리고',
  'Yes': '예',
  'No': '아니요',
  'Or': '또는',
  'Confirm': '확인',
  'Saved success': '성공적으로 저장되었습니다',
  'Warning': '경고',
  'Cancel success': '성공적으로 취소되었습니다',
  'Account binding failure': '계정 연동에 실패했습니다',
  'UPDF Code verify': 'UPDF 인증 코드로 로그인',
  'UPDF Login': 'UPDF 계정 로그인',
  'UPDF Password login': 'UPDF 비밀번호 로그인',
  'UPDF Forgot password': 'UPDF 비밀번호 찾기',
  'UPDF Reset password': 'UPDF 비밀번호 재설정',
  'UPDF Set account info': 'UPDF 계정 정보 설정',
  'UPDF Callback {loginType}': 'UPDF 콜백 {로그인 유형}',
  'UPDF Wechat login': 'UPDF 위챗 로그인',
  'Welcome to': '환영합니다',
  'Wechat': '위챗',
  'Click reload': '클릭하여 다시 로드하세요',
  'Log in by scanning QR code on Wechat<br>and following our official account': '위챗 QR 코드를 스캔하여 로그인하고<br>우리 공식 계정을 팔로우하세요.',
  'Email': '이메일',
  'Phone': '전화번호',
  'Unregistered account will be registered after entering the verification code': '등록되지 않은 전화번호 또는 이메일은 인증 코드를 입력한 후 등록됩니다.',
  'Unregistered email will be registered after entering the verification code': '등록되지 않은 이메일은 인증 코드를 입력한 후 등록됩니다.',
  'Or continue with:': '다음으로 계속하기:',
  'By clicking continue, you accept our': '계속을 클릭함으로써, 귀하는 우리의',
  'License Agreement': '사용권 계약',
  'Privacy Policy': '개인정보 보호정책',
  'Enter your phone number or email...': '전화번호 또는 이메일 주소를 입력하세요...',
  'Enter your email address...': '이메일 주소를 입력하세요...',
  'Please enter a valid phone number or email': '유효한 전화번호 또는 이메일 주소를 입력하세요',
  'Please enter a valid email address': '유효한 이메일 주소를 입력하세요',
  'Please enter your password': '비밀번호를 입력하세요',
  'Enter new password': '새 비밀번호 입력',
  'The new password must be at least {min} characters.': '새 비밀번호는 최소 {min}자 이상이어야 합니다.',
  'The new password must be within {max} characters.': '새 비밀번호는 최대 {max}자 이내여야 합니다.',
  'Nickname must be within {max} characters.': '별명은 최대 {max}자 이내여야 합니다.',
  'Enter your password again': '새 비밀번호를 다시 입력하세요.',
  'Please enter your password again': '새 비밀번호를 다시 입력해 주세요.',
  'Those passwords didn\'t match. Try again.': '비밀번호가 일치하지 않습니다. 다시 시도해 보세요.',
  'Reset success,please log in use new password': '비밀번호 재설정이 성공적으로 완료되었습니다. 새 비밀번호로 로그인해 주세요.',
  'Continue': '계속하기',
  'Check mobile': '전화번호 확인하세요',
  'Check email': '이메일 확인하세요',
  'Please enter the code sent to<br><span>{account}</span>': '<br><span>{account}</span>로 전송된 코드를 입력해 주세요. 코드는 10분 동안 유효합니다.',
  'If you do not receive the email, please check your spam or junk folder.': '이메일을 받지 못한 경우 스팸 메일함을 확인하세요.',
  'Resend': '재전송',
  'seconds remaining to resend code': '코드 재전송까지 남은 시간(초)',
  'Verify Later': '나중에 인증하기',
  'Log in with password': '비밀번호로 로그인',
  'Log in with password-2': '비밀번호로 로그인',
  'Log in with code': '인증 코드로 로그인',
  'OR': '또는',
  'Back': '뒤로가기',
  'Forgot password?': '비밀번호를 잊으셨나요?',
  'Log in': '로그인',
  'Set password': '비밀번호 설정',
  'Reset your password': '비밀번호 재설정',
  'Add a photo': '사진 추가',
  'Your name': '이름',
  'What should we call you?': '어떻게 불러드릴까요?',
  'First name': '이름',
  'Last name': '성',
  'Please enter first name': '이름을 입력하세요.',
  'Please enter last name': '성을 입력하세요.',
  'Please enter your nickname': '별명을 입력하세요.',
  'Set a password': '비밀번호 설정',
  'Please enter new password': '새 비밀번호를 입력하세요.',
  'Set success': '설정이 완료되었습니다.',
  'Log in success': '로그인 성공적으로 완료되었습니다.',
  'Click "<span>Open UPDF</span>" in the above dialog box above to log into your account.': '위의 대화 상자에서 "<span>UPDF 열기</span>"를 클릭하여 계정에 로그인하세요.',
  'Can\'t see the dialog box? Click here.': '대화 상자가 보이지 않나요? 여기를 클릭하세요.',
  'Account center': '계정 센터',
  'Account Center': '계정 센터',
  'Account': '계정 관리',
  'Personal info': '개인 정보',
  'Photo': '아바타',
  'Preferred name': '표시 이름',
  'Email-2': '이메일',
  'UID': 'UID',
  'Mobile phone': '전화번호',
  'Country': '국가',
  'Linked Accounts Manage': '연결된 계정 관리',
  'Select country': '국가 선택',
  'Your Plans of UPDF': 'UPDF 요금제',
  'Upgrade to UPDF Pro to get full access to all features without limits.': 'UPDF Pro로 업그레이드하여 제한 없이 모든 기능에 대한 완전한 액세스 권한을 얻으세요.',
  'Subscriptions': '제품 및 요금제',
  'You can manage you plan in Apple ID settings': 'Apple ID 설정에서 요금제를 관리할 수 있습니다.',
  'Free': '무료',
  'Annual': '연간',
  'Monthly': '월간',
  'Quarterly': '분기별',
  'Perpetual': '영구',
  'Giveaway': '경품',
  'Cancel subscription': '구독 취소',
  'Current Plan': '현재 계획',
  'Renews': '갱신',
  'Expire on': '만료일',
  'VIP Duration': 'VIP 기간',
  'Month': '월',
  'Months': '월',
  'Activate': '활성화',
  'Use Across Devices': '다양한 기기에서 사용',
  'As you already have a subscription plan, activating the "Giveaway" plan would make both plans run on your account, but it will not increase the original subscription time. Are you sure you want to activate the "Giveaway" plan?': '이미 구독 플랜이 있으므로 "기프트" 플랜을 활성화하면 두 플랜이 모두 계정에서 작동하지만, 원래 구독 기간은 연장되지 않습니다. "기프트" 플랜을 활성화하시겠습니까?',
  'Activate the "Giveaway" plan': '"기프트" 플랜 활성화',
  'Password management': '비밀번호 관리',
  'You can set password if you don\'t prefer logging in with codes.': '코드로 로그인하기를 원치 않으면 비밀번호를 설정할 수 있습니다.',
  'Change Password': '비밀번호 변경',
  'Set Password': '비밀번호 설정',
  'Are you sure log out your account?': '정말로 계정에서 로그아웃하시겠습니까?',
  'Log out of UPDF account': 'UPDF 계정에서 로그아웃합니다.',
  'You may not be able to use all features after logging out of your account until you log back in.': '로그아웃 후에는 모든 기능을 제한 없이 사용할 수 없습니다.',
  'Log Out': '로그아웃',
  'Confirm input error': '확인 코드가 올바르지 않습니다.',
  'Permanently delete your personal information and all data, this operation can\'t be recovered. Enter <span style="color: var(--el-color-primary)">{uid}</span> to confirm the operation.': '귀하의 개인 정보와 데이터는 영구적으로 삭제되며 복구할 수 없습니다. 작업을 확인하려면 <span style="color: var(--el-color-primary)">{uid}</span>를 입력해 주세요.',
  'Delete your account': '계정 삭제',
  'Your personal information and all data will be removed permanently and can\'t be recovered.': '귀하의 개인 정보와 모든 데이터는 영구적으로 삭제되며 복구할 수 없습니다.',
  'Delete': '삭제',
  'The avatar must be an image.': '아바타는 이미지여야 합니다.',
  'You will miss the following membership rights when the subscription expired.': '구독이 만료되면 다음과 같은 회원 권한을 잃게 됩니다.',
  'Expire on {date}': '{date}까지 유효',
  'Redeem': '교환',
  'Redeem-2': '교환',
  'The license will be bound to your account, and extend the expiration date.': '교환한 멤버십 또는 요금제의 기간이 계정에 추가됩니다.',
  'Please input license.': '교환 코드를 입력하세요.',
  'Incorrect license code.': '유효하지 않은 교환 코드입니다.',
  'Redeem success.': '성공적으로 교환되었습니다.',
  'Use across Windows, macOS, Android, iOS++No watermark++All annotate tools++Edit PDF text, images and links++Convert PDF to Word, Excel, PPT++OCR Text Recognition++Extract, insert, replace, split pages++Free updates and upgrades': '윈도우, 맥OS, 안드로이드, iOS에서 사용++평가판 워터마크 없음++모든 주석 도구++ PDF 텍스트, 이미지 및 링크 편집++ PDF를 워드, 엑셀, PPT로 변환++OCR 텍스트 인식++페이지 재정렬, 회전, 추출, 삽입, 분할++무료 업데이트 및 업그레이드',
  'Keep UPDF Pro': 'UPDF Pro 유지',
  'Continue Cancellation': '구독 취소 계속',
  'Renew': '갱신',
  'Activate Subscription': '구독 활성화',
  'Success! Your UPDF PRO subscription will be renewed on {date}': '귀하의 구독이 복원되었습니다! 귀하의 UPDF Pro 구독은 {date}에 갱신됩니다.',
  'Upgrade to Pro': 'Pro로 업그레이드',
  'Please enter the new mobile phone number': '새 전화 번호를 입력하세요.',
  'Please enter a valid mobile phone number': '유효한 전화 번호를 입력해주세요.',
  'Please enter a new email address': '새 이메일 주소를 입력해주세요.',
  'Please enter a valid email address-2': '유효한 이메일 주소를 입력해주세요.',
  'Verification code error': '인증 코드 오류',
  'Set': '설정',
  'Change': '변경',
  'Link': '연결',
  'Unlink': '연결 해제',
  'not set': '설정되지 않음',
  'not set-2': '연결되지 않음',
  'Phone Number': '전화번호',
  'Google': '구글',
  'Apple ID': 'Apple ID',
  'Set Phone Number': '전화번호 설정',
  'Please enter the phone number and verification code.': '전화번호와 인증 코드를 입력하세요.',
  'Set Email': '이메일 설정',
  'Please enter the email and verification code.': '이메일과 인증 코드를 입력해주세요.',
  'Please enter the phone number': '전화번호를 입력해주세요.',
  'Please enter your email': '이메일을 입력해주세요.',
  'Verification code': '인증 코드',
  'Send code': '코드 전송',
  'Resend-2': '재전송',
  'please enter the verification code': '인증 코드를 입력해주세요.',
  'Please use wechat to scan the QR code and follow the official account binding': '위챗 QR 코드를 스캔하고 공식 계정을 팔로우하여 계정을 연결해 주세요.',
  'To keep your account safe': '계정 보안 유지를 위해',
  'Please enter the verification code sent to': '{account}으로 전송된 인증 코드를 입력해주세요.',
  'Linked Accounts': '연결된 계정',
  'Binding success': '바인딩 성공',
  'linked': '연결됨',
  'Unbind successfully': '연결 해제 성공',
  'Unbinding failure': '연결 해제 실패',
  'Are you sure you want to untie them': '정말로 해제하시겠습니까?',
  'UCloud Expires On': 'UPDF 클라우드 만료일',
  'UPDF Plan': 'UPDF 프로',
  'Full access to all UPDF features and UCloud benefits.': '모든 UPDF 기능과 UPDF 클라우드 혜택에 대한 완전한 액세스.',
  'Full access to all UPDF features and comes with 1-year UCloud benefits.': '모든 UPDF 기능에 대한 완전한 액세스 및 1년간의 UPDF 클라우드 혜택 제공.',
  'Upgrade to UPDF Pro to get all UPDF features and UCloud benefits.': '모든 UPDF 기능과 UPDF 클라우드 혜택에 대한 액세스를 얻으려면 UPDF Pro로 업그레이드하세요.',
  'Full access to all UPDF features.': '모든 UPDF 기능에 대한 완전한 액세스.',
  'Create a Company': '회사 생성',
  'Please fill in the company information': '회사 정보를 입력해주세요.',
  'Company Name': '회사 이름',
  'Industry Type': '산업 유형',
  'Number of Employees': '직원 수',
  'Set up enterprise account': '기업 계정 설정',
  'Confirm your enterprise account. You will become the administrator with full management rights.': '기업 계정을 확인하세요. 전체 관리 권한이 있는 관리자가 됩니다.',
  'Email Address': '이메일 주소',
  'Email Address or Phone Number': '이메일 주소 또는 전화번호',
  'Please enter the password of {companyName}': '{companyName}의 비밀번호를 입력해주세요.',
  'Your company is created successfully.': '회사가 성공적으로 생성되었습니다.',
  'Invite members to join the company by email or by copying the link.': '이메일을 보내거나 링크를 복사하여 공유하여 회원을 회사에 초대합니다.',
  'Invite members': '회원 초대',
  'Invite Later': '나중에 초대',
  'Send Invitation': '초대장 보내기',
  'Copy Link': '링크 복사',
  'UPDF PRO': 'UPDF Pro',
  'Your account now has full access to all features without limits.': '귀하의 계정은 이제 제한 없이 모든 기능에 액세스할 수 있습니다.',
  'Your account has not been authorized by the administrator': '관리자에 의해 권한이 부여되지 않았습니다.',
  'All': '모두',
  'Authorized': '권한이 부여된',
  'Unauthorized': '권한이 부여되지 않은',
  'Company Logo': '회사 로고',
  'Contact Information': '연락처 정보',
  'Administrator': '관리자',
  'Email-1': '이메일',
  'Phone Number-1': '전화번호',
  'Transfer': '전송',
  'Permanently delete your company information and all data, this operation can not be recovered. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm the operation.': '회사 정보와 모든 데이터를 영구적으로 삭제합니다. 이 작업은 복구할 수 없습니다. 작업을 확인하려면 <span style="color: var(--el-color-primary)">{companyId}</span>을(를) 입력하세요.',
  'Assigned': '할당된',
  'Quick Entry': '빠른 입력',
  'Last Login Time': '최근 로그인 시간',
  'Operation': '조작',
  'Search': '검색',
  'Link copied': '링크 복사',
  'Email, separated by enter': '이메일, 엔터로 구분',
  'This email is already on the list': '이 이메일은 이미 목록에 있습니다.',
  'Invalid Invite Code': '잘못된 초대 코드입니다.',
  'You have joined the company.': '회사에 가입했습니다.',
  'The following accounts are bound to the current login method. Please select the account to log in.': '다음 계정은 현재 로그인 방법에 연결되어 있습니다. 로그인할 계정을 선택해 주세요.',
  'Enter password': '비밀번호 입력',
  'Please enter the password of <span>{username}</span>': '<span>{username}</span>의 비밀번호를 입력하세요.',
  'This account is already logged in': '이 계정은 이미 로그인되어 있습니다.',
  'You have successfully joined {companyName}': '회사에 성공적으로 가입했습니다.',
  'Download UPDF now to share membership benefits': '멤버십 혜택을 공유하려면 UPDF를 다운로드하세요.',
  'Download UPDF': 'UPDF 다운로드',
  'Please Enter..': '입력해주세요..',
  'Full Name': '성명',
  'Please login first': '먼저 로그인하세요',
  'administrator': '관리자',
  'Dissolve Company': '회사 해산',
  'Permanently delete your business information and data. This action is non-recoverable. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm.': '귀사의 정보와 데이터의 영구 삭제는 복구할 수 없습니다. 삭제를 확인하려면 <span style="color: var(--el-color-primary)">{companyId}</span>를 입력하세요.',
  'Accommodation and Food Services': '숙박 및 음식 서비스 업종',
  'Administration, Business Support, and Waste Management Services': '관리, 비즈니스 지원 및 폐기물 관리 서비스 업종',
  'Agriculture, Forestry, Fishing, and Hunting': '농업, 임업, 어업 및 사냥 업종',
  'Arts, Entertainment, and Recreation': '예술, 오락 및 레크리에이션 업종',
  'Construction': '건설 업종',
  'Educational Services': '교육 서비스 업종',
  'Finance and Insurance': '금융 및 보험 업종',
  'Healthcare and Social Assistance': '의료 및 사회 복지 업종',
  'Information and Communication': '정보 및 통신 업종',
  'Manufacturing': '제조 업종',
  'Mining': '광업 업종',
  'Other Services': '기타 서비스 업종',
  'Professional, Scientific, and Technical Services': '전문, 과학 및 기술 서비스 업종',
  'Real Estate, Rental, and Leasing': '부동산, 임대 및 임대 서비스 업종',
  'Wholesale and Retail Trade': '도매 및 소매 업종',
  'Transportation and Warehousing': '운송 및 창고 업종',
  'Utilities': '공공, 전기, 가스, 증기 및 공기 조절 공급 업종',
  'Order No.': '주문번호',
  'Amount': '양',
  'Product': '제품',
  'Payment Time': '지불 시간',
  'Payment Status': '지불 상태',
  'Your order is being processed. It may take from 2 to 6 working days to process your payment using the payment method of Sofort/Pix/Boleto. You will be informed via email once the process is done.': '귀하의 주문이 처리 중입니다. Sofort/Pix/Boleto 중 하나의 결제 방법을 이용하여 결제가 처리되는 데 2일에서 6일 정도 소요될 수 있습니다. 처리 완료 후 이메일로 안내해 드리겠습니다.',
  'Unpaid': '미지급',
  'Failure': '실패',
  'Paid': '지급됨',
  'Refunded': '환불됨',
  'Pending': '보류 중',
  'Expire on:': '만료일:',
  'Card Expired': '카드 만료됨',
  'The payment card can only be changed for orders under subscription. For canceled orders, the renewal has been cancelled, and the payment card cannot be changed. If you need to change the payment card, please renew the subscription of this order in "Subscriptions" first.': '결제 카드는 유효한 정기구독 주문에 대해서만 변경할 수 있습니다. 취소된 주문의 경우 갱신이 취소되었으므로 결제 카드를 변경할 수 없습니다. 결제 카드를 변경해야 하는 경우 먼저 \'구독\'에서 이 주문에 대한 구독을 갱신하세요.',
  'Canceled': '취소됨',
  'Change Card': '카드 변경',
  'Active': '활성',
  'Inactive': '비활성',
  'Credit cards associated with subscription orders can be managed here. Here you can modify the credit card that will be used for future renewals. To cancel or restore a subscription, please operate in "Subscriptions".': '구독 주문과 관련된 신용 카드를 여기에서 관리할 수 있습니다. 여기에서 향후 갱신에 사용될 신용카드를 수정할 수 있습니다. 구독을 취소하거나 복원하려면 "구독"에서 조작하세요.',
  'Security': '보안',
  'Payment Management': '결제관리',
  'Order Information': '주문정보',
  'Pay Again': '다시 지불',
  'Change successfully': '변경 성공',
  'Change failed, please try again': '변경 실패, 다시 시도해주세요.',
  'Order information only includes orders purchased through the website. Applepay and Google Play orders will not be displayed.': '주문 정보는 웹사이트를 통해 구매한 주문만 포함됩니다. Apple Pay와 Google Play 주문은 표시되지 않습니다.',
  'Membership': '회원',
  '(Educational)': '(교육의)',
  'Issue an invoice': '송장 발행',
  'Download invoice': '송장 다운로드',
  'Bill To:': '청구지 주소:',
  'Name': '이름',
  'Address': '주소',
  'ZIP Code': '우편 번호',
  'Submit': '제출',
  'Please check the information carefully. It cannot be modified after submission. Are you sure to submit?': '정보를 신중하게 확인해 주시기 바랍니다. 제출 후에는 수정할 수 없습니다. 꼭 제출하시겠습니까?',
  'Are you sure?': '확실합니까?',
  'Invoice Information': '송장 정보',
  'Must enter 1-20 characters': '1~20자를 입력해야 합니다.',
  'Must enter 1-100 characters': '1~100자를 입력해야 합니다.',
  'Must enter 1-500 characters': '1~500자를 입력해야 합니다.',
  'Must enter 1-200 characters': '1~200자를 입력해야 합니다.',
  'Must enter 1-50 characters': '1~50자를 입력해야 합니다.',
  'Device Management': '장치 관리',
  'Desktop': '데스크탑',
  'Last active': '마지막 활동',
  'Login out': '로그아웃',
  'Mobile': '모바일',
  'After being removed, the device will automatically log out and needs to be logged in again. Do you confirm the operation?': '제거 후, 기기는 자동으로 로그아웃되며 다시 로그인해야 합니다. 이 작업을 확실히 진행하시겠습니까?',
  'Settings': '설정',
  'Avatar': '아바타',
  'Sign Out': '로그아웃',
  'Join Time': '가입 시간',
  'Remove Member': '멤버 제거',
  'Deauthorize': '권한 해제',
  'Authorize': '권한 부여',
  'Authorization': '권한 상태',
  'Company Overview': '회사 개요',
  'Redeem-3': '교환',
  'Buy Licenses': '라이선스 구매',
  'Member Management': '멤버 관리',
  'Deleted Successfully': '삭제 성공',
  'Deauthorized Successfully': '권한 취소 성공',
  'Authorized Successfully': '권한 부여 성공',
  'Redeemed successfully': '교환 완료',
  'Company Settings': '회사 설정',
  'Company Infomation': '회사 정보',
  'The invitation has been sent successfully': '초대가 성공적으로 전송되었습니다.',
  'Incorrect format of email': '잘못된 이메일 형식',
  'Incorrect format of phone number': '잘못된 전화번호 형식',
  'Dissolved successfully': '해체 성공',
  'License View': '기업 라이선스 대시보드',
  'Member View': '멤버 보기',
  'Total Licenses': '총 라이선스 수',
  'Total Members': '총 멤버 수',
  'Reset': '초기화',
  'Number of Members': '멤버 수',
  'Company ID': '회사 ID',
  'No staff selected': '선택된 회원이 없습니다.',
  'Please enter the email': '이메일을 입력해주세요.',
  'Add Member': '회원 추가',
  'Please enter the company name': '회사 이름을 입력해주세요.',
  'Permanently delete your business information and data. This action is non-recoverable.': '귀사의 정보와 데이터의 영구 삭제는 복구할 수 없습니다.',
  'Skip': '건너뛰기',
  'You are not an administrator and do not have permission to access this page.': '관리자 권한이 없어 이 페이지에 접근할 수 없습니다.',
  'Enterprise management': '기업 관리',
  'Flexible configuration, tracking, and management of licenses within your company.': '회사 내 라이센스를 유연하게 구성, 추적 및 관리합니다.',
  'Enterprise management dashboard': '기업 관리 대시보드',
  'Authorization failed': '권한 부여 실패',
  'Buy Now': '지금 구매',
  'Buy': '구매',
  'Insufficient licenses available! Want to buy more licenses?': '라이선스가 부족합니다! 더 많은 라이선스를 구매하시겠습니까?',
  'Privilege grant failed': '권한 부여 실패',
  'Number of Users': '사용자 수',
  'Member Avatar': '회원 아바타',
  'Password must be 6-20 characters, and should have numbers, English letters, or symbols.': '비밀번호는 6-20자여야 하며, 숫자, 영문자 또는 기호를 포함해야 합니다.',
  'Not set': '설정되지 않음',
  'The current account is the administrator of {companyName}, please log in to the enterprise management platform and dissolve the company to complete the deletion.': '현재 계정은 {companyName}의 관리자입니다. 계정을 삭제하려면 기업 관리 대시보드에 로그인하여 회사를 해체하십시오',
  'Permanently and irreversibly delete the member\'s account and all data. Click OK to complete the deletion': '회원의 계정과 데이터는 영구 삭제되며 복구할 수 없습니다. 삭제를 확인하려면 확인을 클릭하세요.',
  'Got it': '알겠습니다',
  'CompanyId Error': '회사 ID 오류',
  'Select': '선택',
  'Enterprise management background': '기업 관리 대시보드',
  'Authorized employees': '권한 부여된 직원',
  'Authorized members': '권한 부여 수',
  'The current account already has a perpetual plan. If you need to redeem it again, please change to another account.': '현재 계정은 이미 영구 계획을 가지고 있습니다. 교환 코드를 사용하려면 다른 계정으로 변경해 주세요.',
  'Number of redemption licences': '교환 라이선스 수',
  'Invalid redemption code': '잘못된 교환 코드',
  'Allocation of Licence Quotas (Number of employees with licences/Total number of licences)': '라이선스 할당량 (라이선스 소지 직원 수/총 라이선스 수)',
  'Authorization of Employee Status (Number of employees with licences/Total number of employees)': '직원 상태 권한 부여 (라이선스 소지 직원 수/총 직원 수)',
  'All the selected enterprise users will be permanently deleted. Do you want to continue?': '선택된 모든 기업 사용자는 영구적으로 삭제됩니다. 계속 진행하시겠습니까?',
  'Share Invitation': '초대장 공유',
  'Add Manually': '수동 추가',
  'Batch Import': '일괄 추가',
  'Export All Member': '모든 회원 내보내기',
  'Export Selected Member': '선택된 회원 내보내기',
  'Account: required. 6-60 characters. The account can not be repeated. It supports numbers, English letters and English symbols.': '계정: 이 항목은 필수입니다. 6자에서 60자 사이여야 하며, 중복될 수 없고 숫자, 영문자, 영문 기호를 지원합니다.',
  'Name: required. The length is limited to 60 characters.': '이름: 이 항목은 필수이며 60자 이내로 입력해야 합니다.',
  'Password: optional. 6-20 characters. It supports numbers, English letters and English symbols.': '비밀번호: 이 항목은 선택 사항입니다. 6자에서 20자 사이이며 숫자, 영문자, 영문 기호를 포함할 수 있습니다.',
  'Mobile phone number: optional. Phone number format.': '휴대폰 번호: 이 항목은 선택 사항입니다. 전화번호 형식을 입력해주세요.',
  'Whether to authorize: optional. Please fill in [Yes], [No]. If not filled, the default is [No].': '권한 부여 여부: 이 항목은 선택 사항입니다. [예], [아니오]를 입력해주세요. 입력하지 않으면 기본값은 [아니오]입니다.',
  'Uploaded Failed': '업로드 실패',
  'The content is wrong. Please modify and reupload.': '내용이 잘못되었습니다. 수정 후 다시 업로드해주세요.',
  'Uploaded Succeed!': '업로드 성공',
  'Employee Table Template.xlsx': '직원 테이블 템플릿.xlsx',
  'You can click to download the Employee table template and fill out the table': '직원 테이블 템플릿을 클릭하여 다운로드한 후 작성하실 수 있습니다.',
  'Copy the following information and notify the user to log in.': '다음 정보를 복사하고 사용자에게 로그인하라고 알려주세요.',
  'Must be letters, digits or symbols': '문자, 숫자 또는 기호여야 합니다.',
  'Please contact administrator to reset password': '비밀번호를 재설정하려면 관리자에게 문의하세요.',
  'Please enter account/email/phone number': '계정/이메일/전화번호를 입력하세요.',
  'Please enter an effective account/email/phone number': '유효한 계정/이메일/전화번호를 입력하세요.',
  'Please enter account/email': '계정/이메일을 입력하세요.',
  'Please enter an effective account/email': '유효한 계정/이메일을 입력하세요.',
  'Drag the template here, or <em>click to upload</em>': '여기에 템플릿을 드래그하거나 <em>클릭하여 업로드</em>하세요.',
  'Account_1': '계정',
  'Inactivated': '비활성화',
  'Activated': '활성화',
  'Deleted': '삭제됨',
  'Register & log in UPDF account You can convert <span>2 files for FREE</span>': 'UPDF 계정을 등록하고 로그인하면 <span>하루에 2개의 파일을 무료로 변환</span>할 수 있습니다.',
  'Register & log in UPDF account You can convert <span>2 files per day</span>for FREE': 'UPDF 계정을 등록하고 로그인하면 <span>하루에 2개의 파일</span>을 무료로 변환할 수 있습니다.',
  '{{.shareName}} added you to {{.companyName}}': '{{.shareName}}님이 {{.companyName}}에 귀하를 추가했습니다.',
  '{{.shareName}} added you to {{.companyName}}. You can share UPDF membership benefits now. The account information is as follows. Remember to save it and log in.': '{{.shareName}}님이 {{.companyName}}에 귀하를 추가했습니다. 이제 모든 UPDF 기능에 전체 액세스 권한이 부여됩니다. 아래에서 귀하의 계정 정보를 확인하십시오. 이를 저장하고 로그인에 사용하시기 바랍니다.',
  'Password': '비밀번호',
  'Full name': '전체 이름',
  'Your password has been reset': '비밀번호가 재설정되었습니다.',
  'Your password has been reset by the administrator. The account information is as follows. Remember to save it and log in.': '귀하의 비밀번호가 관리자에 의해 재설정되었습니다. 아래에서 귀하의 계정 정보를 확인하십시오. 이를 저장하고 로그인에 사용하시기 바랍니다.',
  'Upload the filled out template:': '작성한 템플릿 업로드:',
  'Please enter account': '계정을 입력하세요.',
  'Please enter password': '비밀번호를 입력하세요.',
  'Must enter 6-20 characters': '6-20 글자를 입력해야 합니다.',
  'Please enter 1-30 characters': '1-30 글자를 입력해야 합니다.',
  'Must enter 1-30 characters': '1-30 글자를 입력해야 합니다.',
  'Please enter email': '이메일을 입력하세요.',
  'Please enter an effective email': '유효한 이메일을 입력해주세요.',
  'Please enter phone number': '전화번호를 입력하세요.',
  'Copy': '복사',
  'Only one file can be uploaded': '하나의 파일만 업로드할 수 있습니다',
  'Accounts can not be repeated. Only numbers, letters, and symbols are supported; it is recommended to name accounts with numbers or letters plus a company suffix (for example: abc@updf, 0100@updf) to ensure uniqueness.': '계정 이름은 중복될 수 없습니다. 숫자, 영문자 및 기호만 지원됩니다. 고유성을 보장하기 위해 계정 이름에 숫자나 영문자와 회사 접미사(예: abc@updf, 0100@updf)를 사용하는 것이 좋습니다.',
  'Reason of failure:': '수입 실패 사유',
  'Information copied': '정보 복사됨',
  'Message sent': '메시지 전송 됨',
  'The file can not exceed 10MB': '파일 크기는 10MB를 초과할 수 없습니다',
  'Must enter 6-60 characters': '6-60 글자를 입력해야 합니다',
  'The file exceeds the limit of 30,000 lines, please modify and upload again': '파일이 30,000줄을 초과했습니다. 수정 후 다시 업로드해 주세요.',
  'Support format': '지원 형식',
  'Send a message to notify the user to log in': '사용자에게 로그인하라는 메시지 보내기',
  'Please enter email/phone number': '이메일/전화번호를 입력해주세요',
  'Please enter an effective email/phone number': '유효한 이메일/전화번호를 입력하세요.',
  'Added successfully': '추가 완료되었습니다.',
  'Member Info': '회원 정보',
  'Send': '보내기',
  'The company name only supports Chinese characters': '기업 이름은 한자만 지원합니다',
  'http_error_4023': '교환 코드는 기업용입니다. 사용하려면 기업 관리 대시보드로 이동하세요.',
  'E-mail: optional. Email format.': '이메일: 선택 사항입니다. 이메일 형식. 반복할 수 없습니다.',
  'Phone number: optional. Phone number format.': '전화번호: 선택 사항입니다. 전화번호 형식. 반복할 수 없습니다.',
  'Enterprise name': '기업명',
  'Redeem Now': '지금 교환',
  'Auto-redemption': '자동 상환',
  'You have purchased the Enterprise Plan. Do you want to auto-redeem your plan?': '엔터프라이즈 플랜을 구입했습니다. 요금제를 자동으로 사용하시겠습니까?',
  'Later': '나중에',
  'Redemption code': '상환 코드',
  'Users': '사용자',
  'It is an enterprise license code, please go to Enterprise Management Dashboard to redeem it.': '교환 코드는 기업용입니다. 사용하려면 기업 관리 대시보드로 이동하세요.',
  'Open UPDF': 'UPDF 열기',
  'Personal Account': '개인 계정',
  'Enterprise Account': '기업 계정',
  'Language Settings': '언어 설정',
  'Language': '언어',
  'Click "Open UPDF" to automatically log in to the enterprise account.': '기업 계정에 자동으로 로그인하려면 \'UPDF 열기\'를 클릭합니다.',
  'Click "Enterprise Management Dashboard", you can enter the Management Dashboard to redeem plan, set enterprise information, invite members to join the enterprise, and conduct enterprise management.': '\'기업 관리 대시보드\'를 클릭하면 요금제 사용, 기업 정보 설정, 기업 가입 멤버 초대, 라이선스 관리 등의 작업을 할 수 있습니다.',
  'Company': '회사',
  'Please enter your purchased UPDF redemption code, the successful redemption will increase the number of authorized licenses for the company.': '구입한 UPDF 상환 코드를 입력하십시오. 성공적으로 상환하면 회사에 대해 승인된 라이선스 수가 증가합니다.',
  'Click to Accept': '동의하려면 클릭',
  'Dissolve success': '성공적으로 용해',
  'Upload files up to 100 per month': '월 최대 100개의 파일 업로드',
  'Up to 1000 pages per file': '파일당 최대 1000페이지',
  'Ask questions up to 1000 times per month': '한 달에 최대 1000번 질문하기',
  'Up to 2GB per file': '파일당 최대 2GB',
  '10GB of FREE ADDITIONAL STORAGE': '10GB의 클라우드 저장 공간',
  'You have unlocked advanced AI features': '고급 AI 기능을 잠금 해제했습니다.',
  'UPDF AI Pro Plan': 'AI 어시스턴트',
  'Upgrade': '업그레이드',
  'Upgrade to UPDF AI Pro monthly Plan to unlock more AI features': 'AI 어시스턴트 플랜으로 업그레이드하여 더 많은 AI 기능 잠금 해제하기',
  'Full access to all UPDF AI features and UPDF Cloud benefits': '모든 AI 어시스턴트 및 UPDF 클라우드 기능에 대한 전체 액세스를 제공합니다.',
  'Success! Your UPDF AI PRO subscription will be renewed on {date}': '성공적으로 복구되었습니다! AI 어시스턴트 구독이 {date}에 갱신됩니다.',
  'Keep UPDF AI Pro': 'UPDF Pro AI 유지',
  'Continue with Apple': '애플로 계속하기',
  'Continue with Google': '구글로 계속하기',
  'You can also <span>continue with SSO</span>': '<span>기타 방법</span>으로 계속할 수 있습니다.',
  'Operation successful': '작업 성공',
  'Operation failed, please try again': '작업이 실패했습니다. 다시 시도해 주세요.',
  'Super Admin information': '최고 관리자 정보',
  'Transfer super Admin': '최고 관리자 이전',
  'Confirm to transfer super Admin?': '최고 관리자를 이전을 확인하시겠습니까?',
  'You will automatically log out of the management backend interface after the transfer': '전송 후에는 기업 관리 대시보드에서 자동으로 로그아웃됩니다.',
  'Organization management': '조직관리',
  'Super Admin can add 5 ordinary Admin; ordinary Admin have all the operation rights of the management backend, except the following functions: transfer super Admin; add and remove ordinary Admins; dissolve the company.': '최고 관리자는 5명의 일반 관리자를 추가할 수 있습니다. 일반 관리자는 다음 기능을 제외하고 관리 백엔드의 모든 운영 권한을 갖습니다. 일반 관리자를 추가 및 제거합니다.',
  'Add Admin': '관리자 추가',
  'Admin list': '관리자 목록',
  'Please enter the employee\'s account': '직원의 계좌를 입력해주세요',
  'Confirm to remove Admin?': '관리자를 삭제하시겠습니까?',
  'After removal, the employee will not be able to enter the management backend': '제거 후에는 직원이 관리 백엔드에 들어갈 수 없습니다.',
  'Duplicate addition': '중복 추가',
  'Super admin cannot be added as a normal admin': '최고 관리자는 일반 관리자로 추가할 수 없습니다.',
  'The super admin removes you from the admin of {{.companyName}}. You can continue to use the enterprise account, but you no longer have the authority to manage the enterprise. If you have any questions, please communicate with the super admin in time.': '슈퍼 관리자가 {{.companyName}}의 관리자로부터 당신을 제거했습니다. 계속 기업 계정을 사용할 수는 있지만, 더 이상 기업을 관리할 권한은 없습니다. 궁금한 점이 있으시면, 슈퍼 관리자에게 신속히 문의하시기 바랍니다.',
  'The super admin adds you as a admin of {{.companyName}}. You can log in to the enterprise management backend to manage the enterprise. The admin\'s account password is your UPDF enterprise account password.': '최고 관리자가 귀하를 {{.companyName}}의 관리자로 추가합니다. 귀하는 엔터프라이즈 관리 백엔드에 로그인하여 엔터프라이즈를 관리할 수 있습니다. 관리자의 계정 비밀번호는 귀하의 UPDF 엔터프라이즈 계정 비밀번호입니다.',
  '{{.shareName}} transfers the super administrator of {{.companyName}} to you. You can log in to the enterprise management backend to manage the enterprise. The administrator\'s account password is your UPDF enterprise account password.': '{{.shareName}}은(는) {{.companyName}}의 최고 관리자를 귀하에게 이전합니다. 귀하는 엔터프라이즈 관리 백엔드에 로그인하여 엔터프라이즈를 관리할 수 있습니다. 관리자의 계정 비밀번호는 귀하의 UPDF 엔터프라이즈 계정 비밀번호입니다.',
  'Enterprise management dashboard:': '기업 관리 대시보드:',
  'Notification of transferring enterprise super admin': '기업 최고 관리자 이전 알림',
  'Notification of adding enterprise admin': '기업 관리자 추가 알림',
  'Notification of removing enterprise admin': '기업 관리자 삭제 알림',
  'Administrators cannot be deleted': '관리자를 삭제할 수 없습니다.',
  'A maximum of 5 normal administrators can be added': '일반 관리자는 최대 5명까지 추가 가능',
  'UPDF AI Unlimited': 'AI 어시스턴트',
  'UPDF AI Standard': 'AI 어시스턴트(표준)',
  'UPDF AI Plan': 'AI 어시스턴트',
  'Upload files unlimited per month++Up to 1000 pages per file++Ask questions unlimited times per month++Up to 2GB per file++100GB of FREE ADDITIONAL STORAGE': '월 무제한 파일 업로드++파일당 최대 1000페이지++월 무제한 질문++파일당 최대 2GB++무료 추가 저장용량 100GB',
  'Success! Your {aiType} subscription will be renewed on {date}': '성공! 귀하의 {aiType} 구독이 {date}에 갱신됩니다',
  'Keep UPDF AI Unlimited': 'AI 어시스턴트 유지',
  'Keep UPDF AI Standard': 'AI 어시스턴트 유지(표준)',
  'Organizational License View': '기업 라이선스 대시보드',
  'Unlimited': '무제한',
  'Your company membership benefits will expire in {organizeExpiredTime} days and all membership benefits will be unavailable. Please contact UPDF sales promptly to renew your membership.': '귀하의 기업 요금제는 {organizeExpiredTime}일 후 만료되며, 모든 회원 혜택을 사용할 수 없게 됩니다. 회원 갱신을 위해 UPDF 영업팀에 문의해 주시기 바랍니다.',
  'Your company\'s membership rights have expired and all membership rights are no longer available. Please contact UPDF sales today to renew your membership.': '기업 요금제가 만료되어 모든 회원 권한을 더 이상 사용할 수 없습니다. 회원 자격을 갱신하려면 지금 바로 UPDF 영업팀에 문의하세요.',
  'Function Settings': '기능 설정',
  'Enterprise cloud management': '기업 클라우드 관리',
  'Enterprise AI management': '기업 AI 관리',
  'Turn off': '끄기',
  'Trun on': '켜기',
  'When the function is turned on, employees can use the cloud function; when it is turned off, the cloud function is turned off and employee accounts can only use local files and cannot upload them to the cloud. This feature is enabled by default.': '켬 상태에서는 직원들이 클라우드 기능을 사용할 수 있습니다; 끔 상태에서는 직원들이 로컬 파일만 사용할 수 있고, 파일을 클라우드에 업로드할 수 없습니다. 이 기능은 기본적으로 켜져 있습니다.',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Are you sure?': '클라우드 기능이 꺼지면 사용이 불가능해지며, 업로드한 파일에 접근할 수 없게 됩니다. 정말로 꺼드시겠습니까?',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Since the AI function requires the Cloud to be turned on before it can be used, if you turn off the Cloud, the AI switch will be turned off at the same time. Are you sure?': '클라우드 기능이 꺼지면 사용이 불가능해지며, 업로드한 파일에 접근할 수 없게 됩니다. AI는 클라우드 기능이 켜져 있어야 작동하므로, 클라우드 기능을 끄면 AI도 비활성화됩니다. 정말로 끄시겠습니까?',
  'Once enabled, all Cloud functions under the employee account will be enabled, and files can be uploaded to Cloud. Are you sure?': '켬 상태에서는 직원들이 클라우드 기능을 사용하고 파일을 클라우드에 업로드할 수 있습니다. 정말로 켜시겠습니까?',
  'When the function is turned on, employees can use AI; when it is turned off, the AI function is turned off. This function is a paid function. If you want to use AI, please contact sales': 'AI 어시스턴트 기능이 켜지면 AI를 사용할 수 있습니다. 꺼지면 AI를 사용할 수 없습니다. 아직 AI 어시스턴트 플랜을 구매하지 않으셨다면, 가격 페이지에서 구매하시거나 영업팀에 문의하셔야 합니다.',
  'After closing, all AI functions under the employee account will be closed, and all generated AI conversation content will be inaccessible. Are you sure?': '꺼지면 AI 어시스턴트는 직원들이 사용할 수 없게 되며, 생성된 모든 AI 대화 내용에 접근할 수 없게 됩니다. 정말로 끄시겠습니까?',
  'After it is enabled, all AI functions under the employee account will be enabled. Are you sure?': '켬 상태에서는 직원들이 AI 어시스턴트를 사용할 수 있습니다. 정말로 켜시겠습니까?',
  'This function is a paid function. If you want to use AI membership, please contact sales.': 'AI 어시스턴트를 사용하려면 구독이 필요합니다. 아직 AI 어시스턴트 플랜을 구매하지 않으셨다면, 가격 페이지를 방문하시거나 영업팀에 문의하여 도움을 받으세요.',
  'Using the AI ​​function requires uploading documents to the Cloud. Please turn on the Cloud function first before turning on the AI ​​switch.': 'AI 어시스턴트를 사용하려면 문서를 클라우드에 업로드해야 합니다. AI 어시스턴트를 켜기 전에 클라우드 기능을 켜주세요.',
  'I know': '알겠습니다',
  'Company User': '사용자 수',
  'Company UPDF Licenses': 'UPDF 기업 라이선스',
  'Company AI Licenses': 'AI 어시스턴트 기업 라이선스',
  'UPDF': 'UPDF',
  'Use Of State': '라이선스 상태',
  'Residue': '남은',
  'More Operations': '더 많은 옵션',
  'Buy UPDF Licenses': 'UPDF Pro 구매',
  'Buy AI Licenses': 'AI 어시스턴트 구매',
  'UPDF Authorize': 'UPDF Pro 인증',
  'AI Authorize': 'AI 어시스턴트 승인',
  'UPDF AI': 'AI 어시스턴트',
  'UPDF Deauthorize': 'UPDF Pro 인증 취소',
  'AI Deauthorize': 'AI 어시스턴트 인증 취소',
  'UPDF AI Authorize': 'AI 어시스턴트 인증',
  'Approval Management': '승인 관리',
  'Order Number': '주문 번호',
  'ProductUPDF': '제품',
  'Number': '번호',
  'Created at': '생성됨',
  'Payment Method': '결제 방법',
  'Money': '금액',
  'Subscription': '구독',
  'No Subscription': '구독 없음',
  'UPDF Lifetime': 'UPDF 영구 플랜',
  'AI Annual': 'AI 어시스턴트 연간 플랜',
  'Non payment': '미지급',
  'payment failure': '결제 실패',
  'cancel Subscribing': '구독 취소',
  'Subscribing': '구독',
  'Orders': '주문',
  'Create a personal account': '개인 계정 만들기',
  'CompanyAccount': '계정',
  'Unauthorized employee': '권한 없는 직원',
  'Authorized employee': '권한 있는 직원',
  'Order': '주문',
  'Amount of AI plans to be redeemed': '상환할 AI 플랜의 금액',
  'Amount of UPDF plans to be redeemed': '상환할 UPDF 플랜의 금액',
  'Pay time': '결제 시간',
  'Quantity': '수량',
  'Payment status': '결제 상태',
  'Active Status': '활성 상태',
  'Insufficient licenses available！Please contact sales.': '라이선스가 부족합니다! 가격 페이지를 방문하여 구매하시거나 영업팀에 문의하여 도움을 받으세요.',
  'Please contact the administrator to obtain authorization so that you can use advanced features.': '고급 기능에 대한 접근 권한을 요청하려면 관리자에게 문의하세요.',
  'Administrator Information': '관리자 정보',
  'Transfer Administrator': '관리자 권한 이관',
  'Are you sure to transfer the administrator?': '관리자를 이전하시겠습니까?',
  'You will be automatically logged out of the Enterprise Management Dashboard after transfering the administrator. The new administrator can directly log in Management Dashboard through his account and password.': '관리자를 이관한 후, 자동으로 기업 관리 대시보드에서 로그아웃됩니다. 새로운 관리자는 본인의 계정과 비밀번호로 직접 관리 대시보드에 로그인할 수 있습니다.',
  'Account binding': '계정 연결',
  'Please enter your email address and verification code': '이메일 주소와 인증 코드를 입력하세요',
  'Please input your email': '이메일을 입력하세요',
  'Invalid verification code, please try again': '잘못된 인증 코드입니다. 다시 시도하세요.',
  'Current version': '현재 버전',
  'Check for upgrades': '업데이트 확인',
  'The current version is already the latest version': '현재 버전이 이미 최신 버전입니다.',
  'Upgrade immediately': '즉시 업그레이드',
  'Send verification code': '인증 코드 전송',
  'Account or password error': '계정 또는 암호 오류',
  'Please contact the administrator to reset the password': '비밀번호를 재설정하려면 관리자에게 문의하세요.',
  'Please enter the administrator\'s email': '관리자 이메일을 입력하세요',
  'Please enter the 4-digit verification code sent to {account}. <br>Valid for 10 minutes.': '{account}로 전송된 4자리 인증 코드를 입력하세요. <br>유효 기간은 10분입니다.',
  'Private Enterprise Account': '개인 기업용 계정',
  'This software is about to be downloaded to the server, are you sure?': '이 소프트웨어는 서버에 다운로드됩니다. 진행하시겠습니까?',
  'The server will be upgraded, are you sure?': '서버가 업그레이드됩니다. 진행하시겠습니까?',
  'Confirm Upgrade': '업그레이드 확인',
  'Checking...': '확인 중...',
  'Server Upgrade': '서버 업그레이드',
  'Software Upgrade': '소프트웨어 업그레이드',
  'The upgrade needs to be connected to the Internet, and the latest server configuration can be obtained': '업그레이드에는 최신 서버 구성을 얻기 위한 인터넷 연결이 필요합니다.',
  'Operation failed. Please try again after the server is connected to the Internet': '작업에 실패했습니다. 서버가 인터넷에 연결된 후 다시 시도해 주세요.',
  'Operation failed. Please try again after connecting to the local area network': '작업에 실패했습니다. 로컬 영역 네트워크(LAN)에 연결한 후 다시 시도해 주세요.',
  'No permission. You are about to be automatically logged out': '권한이 없습니다. 곧 자동으로 로그아웃됩니다.',
  'Insufficient license is available! Contact sales to buy more.': '라이선스가 부족합니다! 가격 페이지를 방문하여 구매하시거나 영업팀에 문의하여 도움을 받으세요.',
  'Your annual plan has {expireTime} days to expire, please contact sales to purchase perpetual plan.': '연간 플랜은 {expireTime}일 후 만료됩니다. 가격 페이지를 방문하여 구매하시거나 영업팀에 문의하여 도움을 받으세요.',
  'Password has been reset successfully. Please use the new password to log in.': '비밀번호가 성공적으로 재설정되었습니다. 새 암호를 사용하여 로그인하세요.',
  'This email is used to reset the administrator password: when the administrator forgets the password, click "forgot password" on the login interface, and a verification code can be sent to this email to reset the password (the verification code needs to be connected to the Internet to receive it). When the administrator is transferred, the email will be changed accordingly, and the new administrator can also bind a new email.': '이 이메일은 관리자 비밀번호를 재설정하는 데 사용됩니다: 관리자가 비밀번호를 잊어버린 경우 로그인 화면에서 "비밀번호 찾기"를 클릭하면, 이 이메일로 인증 코드가 전송되어 비밀번호를 재설정할 수 있습니다 (인증 코드 수신을 위해 인터넷 연결이 필요합니다). 관리자가 이관되면 이메일이 변경되며, 새로운 관리자는 새로운 이메일을 바인딩할 수 있습니다.',
  'Your version is already the latest version': '사용 중인 버전이 이미 최신 버전입니다.',
  'The upgrade needs to be connected to the Internet, and the latest software configuration can be obtained': '업그레이드는 인터넷에 연결되어 있어야 하며 최신 소프트웨어를 얻을 수 있습니다.',
  'Change binding': '등록 변경',
  'Privatized Enterprise Account': '민영화된 기업 계정',
  'Enterprise Management Dashboard': '엔터프라이즈 관리 대시보드',
  'When upgrading, all client software will be suspended, please remind employees to save in time': '업그레이드 중에는 모든 클라이언트 소프트웨어가 일시 중지됩니다. 직원들에게 시간에 맞춰 저장하도록 알려주세요.',
  'Upgrade failed, please try again': '업그레이드 실패, 다시 시도해 주세요.',
  'http_error_4024': '해당 교환 코드는 개인 플랜용으로, 기업에는 사용할 수 없습니다.',
  'http_error_4408': '네트워크 연결이 시간 초과되었습니다. 인터넷 연결이 필요합니다.',
  'This version includes bug fixes and performance improvements': '이 버전은 버그 수정 및 성능 개선을 포함합니다.',
  'UPDF Annual': 'UPDF Pro 연간 플랜',
  'Success! Your subscription will be renewed on {data}': '성공! 귀하의 구독은 {data}에 갱신됩니다.',
  'You will miss the membership rights when the subscription expired.': '구독이 만료되면 회원 권한을 잃게 됩니다.',
  '⏰ <span>Expire on</span> {data}': '⏰ <span>만료일</span> {data}',
  'Keep Subscribing': '구독 유지',
  'Active Subscription': '구독 활성화',
  'UPDF Sign Annually': 'UPDF Sign',
  'UPDF Sign Monthly': 'UPDF Sign',
  'Sign': 'UPDF Sign',
  'UPDF Sign': 'UPDF Sign',
  'Your account now has full access to all UPDF Sign features.': '귀하의 계정은 이제 모든 UPDF Sign 기능에 완전히 접근할 수 있습니다.',
  'Full access to all UPDF Sign features and UPDF Cloud benefits.': '모든 UPDF Sign 및 UPDF 클라우드 기능에 완전히 접근할 수 있습니다.',
  'UPDF Sign Authorize': 'UPDF Sign 인증',
  'Buy Sign Licenses': 'UPDF Sign 구매',
  'Amount of Sign plans to be redeemed': '상환 가능한 UPDF Sign 라이선스 수',
  'Sign Authorize': 'UPDF Sign 권한 부여',
  'Sign Deauthorize': 'UPDF Sign 권한 취소',
  'Keep UPDF Sign': 'UPDF Sign 유지',
  'Legally binding digital signature (certified by AATL).++Automatically notify recipients when signature is sent.++Multiple file signing and batch sending.++Save and manage digital signatures for long-term use.++Provides audit trail and certification.': '법적으로 효력이 있는 디지털 서명 (AATL 인증).++서명이 전송되면 수신자에게 자동으로 알림 전송.++여러 파일 서명 및 배치 전송.++디지털 서명을 저장하고 장기적으로 관리.++감사 추적 및 인증 제공.',
  '{number} signature requests per year.': '연간 {number}개의 서명 요청.',
  '{number} signature requests per month.': '매월 {number}개의 서명 요청.',
  'Legally binding digital signature (certified by AATL).': '법적 구속력이 있는 디지털 서명(AATL 인증)',
  'Automatically notify recipients when signature is sent.': '서명이 전송되면 수신자에게 자동으로 알림을 전송합니다.',
  'Multiple file signing and batch sending.': '다중 파일 서명 및 일괄 전송.',
  'Save and manage digital signatures for long-term use.': '디지털 서명을 저장하고 장기적으로 관리합니다.',
  'Provides audit trail and certification.': '감사 추적 및 인증을 제공합니다.',
  '20GB cloud storage.': '20GB 클라우드 스토리지.',
  '24*7 customer service support.': '24*7 고객 서비스 지원.',
  'Register & log in UPDF account You can convert <span>2 files per day</span> for FREE': 'UPDF 계정을 등록하고 로그인하세요. 하루에 <span>2개의 파일을 무료로</span> 변환할 수 있습니다.',
  'The annual membership signature quota is unlimited and cannot be modified after authorization to employees. Confirm the authorization?': 'UPDF 서명 연간 플랜은 무제한 서명 요청을 포함합니다. 직원을 권한 부여하면, 해당 권한을 다른 직원에게 이전할 수 없습니다. 권한 부여를 확인하시겠습니까?',
  'Authorized employees do not support cancellation. If you need to change, you can contact sales to modify it once.': '권한이 부여된 직원은 취소가 지원되지 않습니다. 변경이 필요하시면, 한 번 수정할 수 있도록 영업팀에 문의하시기 바랍니다.',
  'Usage of amount': '사용 개요:',
  'Total signature amount:': '총 서명 요청:',
  'Expiration date:': '만료일：',
  'Remaining amount:': '남은 서명 요청:',
  'Usage of Amount Detail': '자세한 사용 개요:',
  'Amount Consumed': '사용된 서명 요청:',
  'Last Consumption Time': '최종 사용 시간:',
  'According to the billing process of relevant institutions, we will complete the billing for users every Wednesday': '관련 기관의 청구 절차에 따라 매주 수요일에 사용자 청구를 완료합니다.',
  'If you need to create a personal account for use, click here': '개인 계정을 생성하여 사용해야 하는 경우 여기를 클릭하세요.',
  'Cancelled': '취소됨',
  'http_error_403': '권한 없음',
  'http_error_408': '요청 시간 초과. 다시 시도해주세요.',
  'http_error_500': '시스템 또는 매개 변수 오류. 다시 시도해주세요.',
  'http_error_1401': '인증 실패. 입력 데이터를 확인해주세요.',
  'http_error_2001': '계정이 이미 존재합니다.',
  'http_error_2002': '유효하지 않은 검증 코드입니다. 다시 시도해주세요.',
  'http_error_2003': '검증 코드가 너무 많이 전송되었습니다. 나중에 다시 시도해주세요.',
  'http_error_2004': 'IP에서 로그인 시도가 너무 많습니다. 잠시 후 다시 시도해 주세요.',
  'http_error_2005': '비밀번호 시도 5회 초과',
  'http_error_2006': '세션이 만료되었습니다. 다시 로그인해주세요.',
  'http_error_2007': '너무 자주 로그인 및 로그아웃 중입니다.',
  'http_error_2008': '세션 예외가 발생했습니다. 다시 로그인해주세요.',
  'http_error_2009': '로그인되어 있지 않습니다. 로그인해주세요.',
  'http_error_2012': '계정이 연결되었습니다. 계정을 분리하거나 삭제한 후 다시 시도해주세요.',
  'http_error_2403': '계정 또는 비밀번호가 올바르지 않습니다.',
  'http_error_2404': '계정이 존재하지 않습니다.',
  'http_error_2411': '이메일 발송 실패! 다시 시도하거나 이메일 주소를 확인해주세요.',
  'http_error_4004': '갱신을 지원하지 않습니다.',
  'http_error_4005': '라이선스가 사용 중입니다.',
  'http_error_4006': '라이선스가 스크랩되었습니다.',
  'http_error_4007': '라이선스가 오프라인 상태입니다.',
  'http_error_4008': '라이선스가 삭제되었습니다.',
  'http_error_4009': '라이선스가 만료되었습니다.',
  'http_error_4015': '이 쿠폰은 이 제품에는 사용할 수 없습니다.',
  'http_error_4016': '쿠폰 사용 한도에 도달했습니다.',
  'http_error_4019': '상품 데이터를 찾을 수 없습니다.',
  'http_error_4020': '쿠폰이 존재하지 않습니다.',
  'http_error_4021': '주문 데이터를 찾을 수 없습니다.',
  'http_error_4022': '요금제 데이터를 찾을 수 없습니다.',
  'http_error_4026': '사용된 코드가 만료되었습니다.',
  'http_error_4027': '쿠폰이 존재하지 않습니다.',
  'http_error_4028': '이미 영구 회원입니다. 교환할 필요 없습니다.',
  'http_error_4014': '계정이 일치하지 않습니다.',
  'http_error_4401': '서버 토큰 오류 발생',
  'http_error_4404': '데이터를 찾을 수 없습니다.',
  'http_error_4502': '시간이 초과되었습니다. 다시 시도해 주세요.',
  'http_error_6004': '자신을 삭제할 수 없습니다.',
  'http_error_6001': '자신을 권한 부여할 수 없습니다.',
  'http_error_6002': '자신의 권한을 취소할 수 없습니다.',
  'http_error_6003': '라이선스가 부족합니다.',
  'http_error_6005': '초대 코드가 만료되었습니다.',
  'http_error_6506': '내보낸 데이터가 비어 있습니다.',
  'http_error_6507': '가져오기가 완료되지 않았습니다.',
  'http_error_6508': '가져온 파일이 비어 있습니다.',
  'http_error_6509': '유효하지 않은 Excel 형식',
  'http_error_6012': '이메일이 이미 존재합니다',
  'http_error_6013': '전화번호가 이미 존재합니다',
  'http_error_6006': '현재 엔터프라이즈가 비활성화되었습니다.',
  'http_error_2204': '현재 구독 플랜이 활성화되어 있습니다. 계정을 삭제하기 전에 구독을 취소해 주세요.',
  'UPDF Account Center': 'UPDF 계정 센터',
  'Profile': '프로필',
  'Products and Plans': '제품 및 요금제',
  'Payment and Order': '결제 및 주문',
  'Account Settings': '계정 설정',
  'Account Types': '계정 유형',
  'Save Changes': '변경 사항 저장',
  'Newsletter Subscription Preferences': '뉴스레터 구독 환경 설정',
  'Subscribe to our newsletter about news, offers and tips.': '최신 소식과 특별 혜택, 유용한 팁을 담은 뉴스레터를 구독하세요.',
  'Redeem License': '라이선스 사용',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product and Plans” first.': '여기에서 구독 주문에 대한 신용 카드를 관리할 수 있습니다. 신용 카드는 제3자 결제 기관에 의해 저장되며 UPDF에서는 신용 카드 정보를 저장하지 않습니다. 바인딩을 해제해야 하는 경우 먼저 "제품 및 요금제"에서 구독을 취소하세요.',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Pay orders will not be displayed here.': '주문 정보에는 웹사이트를 통해 구매한 주문만 포함됩니다. Apple Pay 및 Google Google Pay 주문은 여기에 표시되지 않습니다.',
  'Card Details': '카드 세부 정보',
  'Device Name': '기기 이름',
  'Location': '위치',
  'Manage': '관리',
  'Linked Account': '연결된 계정',
  'Status': '상태',
  'Actions': '작업',
  'No data': '데이터 없음',
  'Log in with WeChat Scan': 'WeChat 스캔으로 로그인',
  'Log in with Account/Email/Phone Number': '계정/이메일/전화번호로 로그인',
  'Registration is successful! Please fill in the following information': '등록이 완료되었습니다! 다음 정보를 입력하세요',
  'Get Started': '시작하기',
  'Subscribe to our newsletter, Offers and Tips.': '최신 소식과 특별 혜택, 유용한 팁을 담은 뉴스레터를 구독하세요.',
  'Please verify you are human': '인간인지 확인하세요',
  'Let us get to know you better': '당신을 대해 더 많이 알려주세요.',
  'How do you plan to use UPDF?': 'UPDF를 어떻게 사용할 계획입니까?',
  'For personal use': '개인용',
  'For work': '업무용',
  'For my study or education work': '학습 또는 교육용',
  'How did you hear about us?': '어떻게 저희를 알게 되셨습니까?',
  'Search (Google, Bing, etc.)': '검색(Google, Bing 등)',
  'Internet(newsletter, publication, blog etc.)': '인터넷(뉴스레터, 출판물, 블로그 등)',
  'Internet ads': '인터넷 광고',
  'Youtube': 'YouTube',
  'Tiktok': 'Tiktok',
  'Social media(Linkedin, Facebook, X, instagram etc.)': '소셜 미디어(Linkedin, Facebook, X, instagram 등)',
  'From a friend or colleague': '친구 또는 동료로 부터',
  'Others(please specify)': '기타 (구체적으로 기재)',
  'Please specify': '구체적으로 작성해 주세요',
  'What features do you plan to use with UPDF?': '어떤 기능을 사용할 계획입니까?',
  'AI': 'AI',
  'Edit PDF': 'PDF 편집',
  'Annotate PDF': 'PDF 주석 달기',
  'Convert PDF': 'PDF 변환',
  'OCR': 'OCR',
  'Create, fill and sign PDFs': 'PDF 만들기, 채우기 및 서명',
  'Organize PDF pages': 'PDF 페이지 구성',
  'Redact and protect PDFs': 'PDF 편집 및 보호',
  'I don\'t know yet': '아직 모르겠습니다.',
  'What’s your age group?': '귀하의 나이대는 어떻게 되나요?',
  'Under 18': '18세 미만',
  '18-24': '18-24',
  '25-34': '25-34',
  '35-44': '35-44',
  '45-54': '45-54',
  '55-64': '55-64',
  '65 and over': '65세 이상',
  'I prefer not to say': '말하고 싶지 않음',
  'What kind of work do you do?': '어떤 종류의 일을 하시나요?',
  'Select your role or job title': '역할 또는 직책을 선택하세요',
  'Education (students or education Staff)': '교육(학생 또는 교육 직원)',
  'Healthcare': '헬스케어',
  'IT': 'IT',
  'Finance': '금융',
  'Legal': '법률',
  'Creative industries': '창의 산업',
  'Engineering': '엔지니어링',
  'Goverment and public service': '정부 및 공공 서비스',
  'Non-profit and NGOs': '비영리 및 NGO',
  'Media and entertainment': '미디어 및 엔터테인먼트',
  'Marketing and advertising': '마케팅 및 광고',
  'Energy and utilities': '에너지 및 유틸리티',
  'Manufacturing_1': '제조업',
  'Real estate': '부동산',
  'Human resource': '인사',
  'Telecommunication': '통신',
  'Consulting': '컨설팅',
  'Building and construction': '건축 및 건설',
  'Retired': '은퇴',
  'Others': '기타',
  'Tell us a bit more': '조금 더 알려주세요.',
  'Next': '다음',
  'Skip All': '모두 건너뛰기',
  'Finish': '마침',
  'Registration is successful!': '등록이 완료되었습니다!',
  'Change Payment Method': '결제 수단 변경',
  'http_error_1400': '사람 인증에 실패했습니다.',
  'http_error_2400': '이메일 인증에 실패했습니다.',
  'http_error_6011': '이미 등록된 계정입니다.',
  'Feedback': '피드백',
  'Very Dissatisfied': '매우 불만족',
  'Dissatisfied': '불만족',
  'Neutral': '중립',
  'Satisfied': '만족',
  'Very Satisfied': '매우 만족',
  'Attachment': '첨부 파일',
  'Is there anything we can help you with?': '무엇을 도와드릴까요?',
  'Your email': '이메일',
  'Hello, we have received your feedback and will respond to you as soon as possible. Please be patient, and thank you for your understanding.': '안녕하세요, 귀하의 피드백을 접수하였으며 가능한 빨리 답변해 드리겠습니다. 잠시 기다려 주세요. 이해해 주셔서 감사합니다.',
  'Submission Failed': '제출 실패',
  'Please correctly fill in your email address.': '이메일 주소를 올바르게 입력하세요.',
  'Invalid email address, please re-enter.': '이메일 주소가 잘못되었습니다. 다시 입력하세요.',
  'Please provide detailed feedback content.': '자세한 피드백 내용을 제공해 주세요.',
  'Unbind Card': '카드 해제',
  'Are you sure you want to unlink this credit card?': '이 신용카드의 설정을 해제하시겠습니까?',
  'Unbind': '바인딩 해제',
  'Use email verification': '이메일 인증을 사용하세요',
  'Use phone verification': '휴대폰 번호를 사용하여 인증하세요',
  'Permanently delete your personal information and all data, this operation can’t be reconvered.': '귀하의 개인 정보와 모든 데이터는 영구적으로 삭제되며 복구할 수 없습니다.',
  'Please select one of the currently linked accounts to receive the verification code to proceed with your account deactivation.': '검증을 위해 바인딩된 계정 중 하나를 선택해주세요.',
  'Other verification methods': '기타 검증 방법',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time and <a href="#" class="change-pass">change the password</a>.': '이 계정에 로그인할 권한이 있는 모든 기기가 여기에 표시됩니다. 특정 기기가 계정에 계속 로그인하는 것을 원하지 않는 경우, 해당 기기를 제거하고<a href="#" class="change-pass">비밀번호를 변경</a>할 수 있습니다.',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time.': '이 계정에 로그인할 권한이 있는 모든 기기가 여기에 표시됩니다. 특정 기기가 계정에 계속 로그인하는 것을 원하지 않는 경우, 제때에 기기를 제거하고 비밀번호를 변경할 수 있습니다.',
  '<span>{inviteNickName}</span> invites you to join <span>{companyName}</span> to share UPDF membership benefits.': '<span>{inviteNickName}</span>님이 <span>{companyName}</span>에 가입하여 UPDF 멤버십 혜택을 공유하도록 초대합니다.',
  'You’ve been invited': '초대를 받았습니다',
  'Free Trial': '무료 체험',
  'Accept now to access exclusive UPDF membership benefits.': '지금 초대를 수락하고 UPDF 멤버십의 독점 혜택을 누려보세요.',
  'Accept Invitation': '초대 수락',
  'Welcome aboard! You’re all set.': '환영합니다! 모두 준비가 완료되었습니다.',
  'Download now to share membership benefits.': '다운로드하고 로그인하여 UPDF의 모든 기능을 잠금 해제하세요.',
  'Start Using UPDF': 'UPDF 시작하기',
  'Account Details': '계정 세부 정보',
  'After unsubscribing, you will no longer receive our email notifications, news, offers, and tips.': '구독을 취소하면 뉴스, 혜택, 팁에 대한 이메일을 더 이상 받지 않게 됩니다.',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product & Plans” first.': '여기에서 구독 결제에 사용된 신용 카드를 관리할 수 있습니다. 신용 카드는 제3자 결제 기관에 저장되며, UPDF는 신용 카드 정보를 저장하지 않습니다. 카드 연결을 해제하려면 먼저 "제품 및 요금제"에서 구독을 취소하세요.',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Google Pay orders will not be displayed here.': '주문 정보에는 UPDF 공식 웹사이트를 통해 이루어진 주문만 표시됩니다. Apple Store나 Google Play Store 또는 제3자 플랫폼에서 이루어진 주문은 여기에 표시되지 않습니다.',
  'Work': '직업',
  'Age': '연령',
  'Please enter the code sent to<br><span>{account}</span>.': '<span>{account}</span>에 전송된 인증 코드를 입력하세요.',
  'The code is valid for 10 minutes.': '코드는 10분 동안 유효합니다.',
  'SSO Log in': 'SSO 로그인',
  'Upgrade AI Assistant to unlock more AI features': 'AI 어시스턴트를 업그레이드하여 더 많은 AI 기능 활성화',
  'Profile Picture': '프로필 사진',
  'Account Deletion Confirmation': '계정 삭제 확인',
  'Email/phone number': '이메일/전화번호',
  'Account/email/phone number': '계정/이메일/전화번호',
  'Account/email': '계정/이메일',
  'Get our desktop/mobile app': 'UPDF 데스크톱/모바일 앱 다운로드',
  'Plan Types': '요금제 유형',
  'Details': '세부 정보',
  'Redeemable {isProduct} Membership Duration:': '사용 가능한 {isProduct} 멤버십 기간:',
  'Redeemable Membership Duration:': '사용 가능한 멤버십 기간:',
  'Tax Code': '세금 코드',
  'http_error_4031': '이미 요금제 사용중이므로 다시 구매할 필요가 없습니다.',
  'Send code_2': '코드 전송',
  'View Plans': '요금제 보기',
  'Add Credit Card': '신용 카드 추가',
  'Account Information': '계정 정보',
  'There are no orders. Would you like to upgrade your plan? <br>Please visit the pricing page to make a purchase.': '주문이 없습니다. 플랜을 업그레이드하시겠습니까? <br>구매하려면 가격 페이지를 방문하세요.',
  'Human-machine verification failed, <span>click to retry</span>': '인간-기계 검증에 실패했습니다. <span>다시 시도하려면 클릭하세요</span>.',
  'Subscribed Successfully': '성공적으로 구독 완료',
  'Unsubscribe': '구독 취소',
  'Upgrade to UPDF Sign Plan to unlock more Sign features': '더 많은 Sign 기능을 사용하려면 UPDF Sign Plan으로 업그레이드하세요.',
  'Subscribe': '신청',
  'Please scan the QR code using WeChat': 'QR코드를 스캔하려면 WeChat을 사용하세요.',
  'Enter your redemption code': '귀하의 교환 코드를 입력하세요',
  'Credit Card': '신용 카드',
}